module.exports = __webpack_public_path__ + "img/arrow-circle-down-left.39b48ac7.svg";